import React, { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getBookingHistoryAction } from "../../../../Services/Store/Actions/BookingsAction";
import {
  BookingItemType,
  PaginationType,
} from "../../../../Constants/Interfaces";
import RightSlidingPanel from "../../../Admin/Components/RightSlidingPanel";
import BookingInfoPanel from "./BookingInfoPanel";
import Pagination from "../../../../Components/Pagination";
import ActionMenu from "../../../../Components/ActionMenu";
import { renderBookingStatus } from "./bookingStatus";

interface BookingHistoryListType {
  search: string;
}

const BookingHistoryList: React.FC<BookingHistoryListType> = ({
  search = "",
}) => {
  const dispatch = useDispatch();

  const { historyList } = useSelector((state: any) => state.bookings);

  const [loading, setLoading] = useState(false);
  const [bookings, setBookings] = useState([]);
  const [pagination, setPagination] = useState<PaginationType | null>(null);

  const [rightSidePanel, setRightSidePanel] = useState<{
    show: boolean;
    item: BookingItemType | null;
  }>({
    show: false,
    item: null,
  });

  const getBookingsList = (page: number) => {
    if (!loading) {
      setLoading(true);
      const params = {
        page,
        limit: 20,
        search,
      };

      getBookingHistoryAction(params, dispatch)
        .then((res) => {
          if (res.type === "success") {
            setPagination(res.pagination);
          }
        })
        .catch((err) => {
          console.log("ERR: ", err);
        })
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    setBookings(historyList);
  }, [historyList]);

  useEffect(() => {
    getBookingsList(1);
  }, []);

  console.log("bookings :", bookings);

  return (
    <div className="listing-tables">
      <Table responsive>
        <thead>
          <tr>
            <th>Space Name</th>
            <th>Amount</th>
            <th>Booking Date</th>
            <th style={{ width: 100, textAlign: "center" }}>Status</th>
            <th className="action-col">Action</th>
          </tr>
        </thead>

        <tbody>
          {!loading && bookings.length === 0 && (
            <tr>
              <td colSpan={5} align="center">
                No Bookings available
              </td>
            </tr>
          )}
          {bookings.length > 0 &&
            bookings.map((item, index) => (
              <tr key={`booking-${item.id}`}>
                <td>{item?.space?.name || ""}</td>
                <td>${item?.grossAmount}</td>
                <td>
                  {item &&
                    item.startDate &&
                    moment(item.startDate).format("MM/DD/YYYY")}
                </td>
                <td align="center">{renderBookingStatus(item?.status)}</td>
                <td className="action-col">
                  <ActionMenu
                    items={[
                      {
                        label: "View Details",
                        icon: faChevronRight,
                        onClick: () => setRightSidePanel({ show: true, item }),
                      },
                    ]}
                  />
                </td>
              </tr>
            ))}

          {loading && (
            <tr>
              <td colSpan={5} align="center">
                <FontAwesomeIcon icon={faSpinner} spin />
              </td>
            </tr>
          )}
        </tbody>

        <tfoot>
          <tr>
            <td colSpan={5}>
              <Pagination
                pagination={pagination}
                onPageChange={(page) => getBookingsList(page)}
              />
            </td>
          </tr>
        </tfoot>
      </Table>

      {rightSidePanel.show && (
        <RightSlidingPanel
          title={`Booking Info`}
          show={rightSidePanel.show}
          onClosePanel={() => setRightSidePanel({ show: false, item: null })}
        >
          <BookingInfoPanel
            showActionBtns="No"
            item={rightSidePanel.item}
            listType="paid"
            closePanel={() => setRightSidePanel({ show: false, item: null })}
          />
        </RightSlidingPanel>
      )}
    </div>
  );
};

export default BookingHistoryList;
